import { useState } from 'react';
import { Switch } from '@headlessui/react';

interface ToggleSwitchProps {
    enabled: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    /** 'compact' = smaller for tight layouts (e.g. Session board on 14" screens) */
    size?: 'default' | 'compact';
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ enabled, onChange, disabled = false, size = 'default' }) => {
  const isCompact = size === 'compact';
  return (
    <Switch
      checked={enabled}
      onChange={onChange}
      disabled={disabled}
      className={`${enabled ? 'bg-blue-600' : 'bg-blue-200'} 
        relative inline-flex items-center rounded-full transition-colors
        ${isCompact ? 'h-4 w-9' : 'h-5 w-10'}
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <span
        className={`${
          enabled ? (isCompact ? 'translate-x-5' : 'translate-x-6') : (isCompact ? 'translate-x-0.5' : 'translate-x-1')
        } inline-block transform rounded-full bg-white transition-transform ${isCompact ? 'h-2.5 w-2.5' : 'h-3 w-3'}`}
      />
    </Switch>
  );
}

export default ToggleSwitch;